<script setup>
const stage = ref(0);
const maxStage = 3;

// Element visibility
const stagesRef = ref(null);

let autoTimer;
onMounted(() => {
  autoTimer = setInterval(() => {
    stage.value = stage.value < maxStage ? stage.value + 1 : 0;
  }, 3000);
});
onBeforeUnmount(() => {
  if (autoTimer) clearInterval(autoTimer);
});

const steps = [
  {
    title: "Start",
    description: "Prosta, funkcjonalna strona, która działa tu i teraz.",
    features: ["Hero + sekcje", "Formularz kontaktowy", "Mapa dojazdu"],
  },
  {
    title: "Rozwój",
    description: "Dodajesz sekcje i treści, kiedy rośniesz.",
    features: ["Portfolio/realizacje", "Opinie klientów", "Wielojęzyczność"],
  },
  {
    title: "Funkcje",
    description: "Rezerwacje, blog, sklep – gdy będziesz gotowy.",
    features: ["Blog/aktualności", "Sklep (e‑commerce)", "System rezerwacji"],
  },
  {
    title: "Integracje",
    description: "Płatności, CMS, automatyzacje – bez pośpiechu.",
    features: ["Płatności online", "Integracja z CMS", "Analityka i automatyzacje"],
  },
];
</script>

<template>
  <section
    class="grid items-start gap-10 lg:grid-cols-2 font-iq-paragraph leading-iq-paragraph tracking-iq-paragraph text-iq-paragraph-color"
  >
    <FlexuilibH2
      class="space-y-6 px-2 md:px-0"
      badge="Elastyczny rozwój bez stresu"
      h2="Zacznij od
    podstaw – rozbuduj, kiedy zechcesz"
      body="Nie musisz mieć wszystkiego od razu. Możesz
    zacząć od prostej, funkcjonalnej strony, która działa tu i teraz – i dokładnie spełnia
    Twoje potrzeby. A kiedy Twój biznes się rozwinie, strona rozwija się razem z nim.
    Dodajemy nowe sekcje, funkcje i integracje, gdy tylko będziesz gotowy. Zero stresu,
    pełna elastyczność – bo dobra strona rośnie razem z Twoją firmą."
      :cta="{
        label: 'Zacznij od prostej strony ➜',
        path: '/cennik',
      }"
    />

    <!-- RIGHT: Interactive growth preview -->
    <div class="relative" ref="stagesRef">
      <div class="rounded-3xl border border-gray-200 bg-white p-6 shadow-lg">
        <div class="mb-5 flex items-start justify-between gap-4">
          <div>
            <p class="text-sm font-medium">Podgląd rozwoju</p>
            <h3 class="text-xl font-semibold">Twoja strona rośnie etapami</h3>
          </div>
          <span class="rounded-full border border-gray-200 bg-gray-50 px-3 py-1 text-xs"
            >Etap {{ stage + 1 }} z {{ maxStage + 1 }}</span
          >
        </div>

        <!-- Stepper Cards -->
        <ol class="space-y-3" aria-live="polite" aria-atomic="true">
          <Step
            v-for="(s, i) in steps"
            :key="s.title"
            :index="i"
            :title="s.title"
            :desc="s.description"
            :features="s.features"
            :active="i <= stage"
          />
        </ol>
      </div>
    </div>
  </section>
</template>
